import React, { useEffect, useState } from "react";

import { Field, useFormikContext } from "formik";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import pt from "date-fns/locale/pt-BR";

import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  Grid,
  GridItem,
  RadioGroup,
  Stack,
} from "@chakra-ui/react";

import Group from "../../../ServicosAcolhimento/Visualizar/Group";

import { RadioButtonField } from "../../../../components/RadioButtonField";
import { useAppContext } from "../../../../../Context/MessageContextProvider";
import { hasFormChanged } from "../../../../utils/hasFormChanged";
import CustomFormApadriamento from "../../../../components/CustomFormApadriamento";
import { isAfter, isBefore, isValid, parse, startOfDay } from "date-fns";
import Swal from "sweetalert2";

export const ApadrinhamentoCadastrar = ({ initialValues, valuesProps }) => {
  const { setFieldValue, values, setFieldError } = useFormikContext();
  const { setCadastrarApadrinhamentoCrianca, primeiraMovimentacao } =
    useAppContext();
  const [dataFimApadrinhamentoStatus, setDataFimApadrinhamentoStatus] =
    useState([]);

  const url = window.location.href;

  const [dataInicioApadrinhamentoStatus, setDataInicioApadrinhamentoStatus] =
    useState([]);

  useEffect(() => {
    setDefaultLocale("pt-br");
    registerLocale("pt-br", pt);
  }, []);

  useEffect(() => {
    if (
      (initialValues.sendoApadrinhado === "N" ||
        initialValues.sendoApadrinhado === "I") &&
      values.sendoApadrinhado === "S"
    ) {
      setFieldValue("pessoasProgramaApadrinhamento", [
        {
          tipoPessoaProgApadrinha: "",
          nomePessoaApadrinhamento: "",
          dataInicioApadrinhamento: "",
          dataFimApadrinhamento: "",
          informacaoComplementar: "",
          id: 0,
        },
      ]);
    }
  }, [initialValues.sendoApadrinhado, values.sendoApadrinhado, setFieldValue]);

  useEffect(() => {
    if (
      (initialValues.incluidoProgApadrinh === "N" ||
        initialValues.incluidoProgApadrinh === "I") &&
      values.incluidoProgApadrinh === "S"
    ) {
      setFieldValue("sendoApadrinhado", "");
    }
  }, [
    initialValues.incluidoProgApadrinh,
    values.incluidoProgApadrinh,
    setFieldValue,
  ]);

  useEffect(() => {
    const statusArray = values?.pessoasProgramaApadrinhamento?.map(
      (item, index) => {
        const dataInicio = parse(
          item.dataInicioApadrinhamento,
          "dd/MM/yyyy",
          new Date()
        );
        const dataFim = parse(
          item.dataFimApadrinhamento,
          "dd/MM/yyyy",
          new Date()
        );

        const dataInicioValida =
          isValid(dataInicio) && item?.dataInicioApadrinhamento?.length === 10;
        const dataFimValida =
          isValid(dataFim) && item?.dataFimApadrinhamento?.length === 10;

        if (dataInicioValida && dataFimValida && isAfter(dataInicio, dataFim)) {
          setFieldError(
            `pessoasProgramaApadrinhamento[${index}].dataFimApadrinhamento`,
            ""
          );
          return { menor: dataFimValida ? true : false };
        } else {
          return { menor: false };
        }
      }
    );

    setDataFimApadrinhamentoStatus(statusArray);
  }, [values?.pessoasProgramaApadrinhamento, setFieldError]);

  useEffect(() => {
    if (
      url.includes("editar") &&
      initialValues?.pessoasProgramaApadrinhamento &&
      initialValues?.pessoasProgramaApadrinhamento.length > 0 &&
      values?.pessoasProgramaApadrinhamento &&
      values?.pessoasProgramaApadrinhamento.length > 0 &&
      (((values.sendoApadrinhado === "N" || values.sendoApadrinhado === "I") &&
        initialValues.incluidoProgApadrinh === "S") ||
        (initialValues.incluidoProgApadrinh === "S" &&
          (values.incluidoProgApadrinh === "N" ||
            values.incluidoProgApadrinh === "I")))
    ) {
      Swal.fire({
        title: "Atenção!",
        html: "Existe apadrinhamento em vigência",
        icon: "warning",
        confirmButtonText: "Fechar",
        confirmButtonColor: "#169499",
      });
      setFieldValue("incluidoProgApadrinh", "S");
      setFieldValue("sendoApadrinhado", "S");
    }
  }, [
    setFieldValue,
    values?.incluidoProgApadrinh,
    initialValues.incluidoProgApadrinh,
    values?.pessoasProgramaApadrinhamento,
    values?.sendoApadrinhado,
    initialValues?.pessoasProgramaApadrinhamento,
    url,
  ]);

  useEffect(() => {
    const statusArray = values?.pessoasProgramaApadrinhamento?.map(
      (item, index) => {
        const dataInicio = parse(
          item.dataInicioApadrinhamento,
          "dd/MM/yyyy",
          new Date()
        );

        const date = new Date(primeiraMovimentacao);
        const formattedDate = date.toLocaleDateString("pt-BR");
        const dataInicioValida =
          isValid(dataInicio) && item?.dataInicioApadrinhamento?.length === 10;

        const futura =
          dataInicioValida && isAfter(startOfDay(dataInicio), new Date());
        const menor =
          dataInicioValida &&
          isBefore(
            startOfDay(
              parse(item.dataInicioApadrinhamento, "dd/MM/yyyy", new Date())
            ),
            startOfDay(parse(formattedDate, "dd/MM/yyyy", new Date()))
          );

        if (menor || futura) {
          setFieldError(
            `pessoasProgramaApadrinhamento[${index}].dataInicioApadrinhamento`,
            ""
          );
        }
        return { menor: !!menor, futura: !!futura };
      }
    );

    setDataInicioApadrinhamentoStatus(statusArray);
  }, [
    values?.pessoasProgramaApadrinhamento,
    setFieldError,
    primeiraMovimentacao,
  ]);

  return (
    <Group title="Programa de Apadrinhamento">
      <Grid
        mt="15px"
        templateColumns="repeat(3, 1fr)"
        gap={values?.incluidoProgApadrinh === "S" ? "25px" : ""}
        rowGap={values?.incluidoProgApadrinh === "S" ? "20px" : ""}
      >
        <GridItem colSpan={{ base: 2, lg: 1 }} zIndex={"3"}>
          {setCadastrarApadrinhamentoCrianca(
            hasFormChanged(initialValues, valuesProps)
          )}

          <Field name="incluidoProgApadrinh">
            {({ field, form }) => (
              <FormControl
                isInvalid={
                  form.errors.incluidoProgApadrinh &&
                  form.touched.incluidoProgApadrinh
                }
                id="incluidoProgApadrinh"
                width="max-content"
                zIndex={"999"}
              >
                <FormLabel
                  color="#5F6377"
                  whiteSpace={"nowrap"}
                  height={"10px"}
                  fontWeight="500"
                  fontSize="14px"
                  lineHeight="19.6px"
                  mb={6}
                >
                  Está Incluída no Programa de Apadrinhamento?
                </FormLabel>
                <RadioGroup
                  value={field.value}
                  onChange={(value) =>
                    setFieldValue("incluidoProgApadrinh", value)
                  }
                >
                  <Stack direction="row">
                    <RadioButtonField
                      fieldName="incluidoProgApadrinh"
                      value="S"
                      label="Sim"
                    />
                    <RadioButtonField
                      fieldName="incluidoProgApadrinh"
                      value="N"
                      label="Não"
                    />
                    <RadioButtonField
                      fieldName="incluidoProgApadrinh"
                      value="I"
                      label="Sem Informação"
                    />
                  </Stack>
                </RadioGroup>
                <FormErrorMessage mt="-1" mr="-14">
                  {form.errors.incluidoProgApadrinh}
                </FormErrorMessage>
              </FormControl>
            )}
          </Field>
        </GridItem>
        <GridItem colSpan={{ lg: 2 }} />
        {values.incluidoProgApadrinh === "S" ? (
          <GridItem colSpan={{ base: 2, lg: 1 }} zIndex={"1"}>
            <FormLabel
              color="#5F6377"
              whiteSpace={"nowrap"}
              height={"10px"}
              fontWeight="500"
              fontSize="14px"
              lineHeight="19.6px"
              mb={6}
            >
              Está Sendo Apadrinhado?*
            </FormLabel>
            <Field name="sendoApadrinhado">
              {({ field, form }) => (
                <FormControl
                  isInvalid={
                    form.errors.sendoApadrinhado &&
                    form.touched.sendoApadrinhado
                  }
                  id="sendoApadrinhado"
                  width="max-content"
                  zIndex={"2"}
                >
                  <RadioGroup
                    value={field.value}
                    onChange={(value) =>
                      setFieldValue("sendoApadrinhado", value)
                    }
                  >
                    <Stack direction="row">
                      <RadioButtonField
                        fieldName="sendoApadrinhado"
                        value="S"
                        label="Sim"
                      />
                      <RadioButtonField
                        fieldName="sendoApadrinhado"
                        value="N"
                        label="Não"
                      />
                      <RadioButtonField
                        fieldName="sendoApadrinhado"
                        value="I"
                        label="Sem Informação"
                      />
                    </Stack>
                    <FormErrorMessage mt="-1" mr="-14">
                      {form.errors.sendoApadrinhado}
                    </FormErrorMessage>
                  </RadioGroup>
                </FormControl>
              )}
            </Field>
          </GridItem>
        ) : (
          ""
        )}

        {values.sendoApadrinhado === "S" &&
        values.incluidoProgApadrinh === "S" ? (
          <>
            <GridItem colSpan={{ base: 3, lg: 3 }}>
              <CustomFormApadriamento
                dataFimApadrinhamentoStatus={dataFimApadrinhamentoStatus}
                dataInicioApadrinhamentoStatus={dataInicioApadrinhamentoStatus}
              />
            </GridItem>
          </>
        ) : (
          ""
        )}

        <GridItem colSpan={{ lg: 2 }} />
      </Grid>
    </Group>
  );
};
